class MatchEditController {
  constructor(
    MatchesFactory,
    JudgesFactory,
    $rootScope,
    $state,
    $filter,
    ngDialog,
    $stateParams
  ) {
    "ngInject";
    const vm = this;

    let $date = $filter("date");

    vm.matchId = $stateParams.id;

    vm.$onInit = () => {
      vm.rootScope = $rootScope;
      vm.match = {};
      vm.judges = [];
      vm.selectedJudges = [];
      JudgesFactory.getAll().then((response) => {
        vm.judges = response.data;
        if (vm.matchId) {
          MatchesFactory.getOne(vm.matchId, { include: "matchJudges" }).then(
            (response) => {
              vm.match = response.data;
              vm.match.official = vm.match.official === 1;
              vm.match.round_1_mobile_open = vm.match.round_1_mobile_open === 1;
              vm.match.round_2_mobile_open = vm.match.round_2_mobile_open === 1;
              vm.match.cup = vm.match.cup === 1;
              vm.match.championship = vm.match.championship === 1;
              if (vm.match.hasOwnProperty("matchJudges")) {
                vm.selectedJudges = [];
                Object.entries(vm.match.matchJudges).forEach(([key, value]) => {
                  let judge = vm.judges.filter((judge) => {
                    if (judge.id === value.judge_id) {
                      return judge;
                    }
                  });
                  if (judge.length === 0) {
                    return;
                  }
                  vm.selectedJudges.push(judge[0]);
                });
              }
            }
          );
        }
      });
    };

    let dateTimePickerDefaultConfig = {
      startView: "day",
      minView: "day",
    };
    vm.matchDatePicker = Object.assign(dateTimePickerDefaultConfig, {
      dropdownSelector: "#matchDate",
    });
    vm.matchRegistrationStartDatePicker = Object.assign(
      dateTimePickerDefaultConfig,
      { dropdownSelector: "#registrationStart" }
    );
    vm.matchRegistrationEndDatePicker = {
      startView: "day",
      minView: "hour",
      dropdownSelector: "#registrationEnd",
    };

    vm.submitMatch = () => {
      vm.match.match_date = $date(vm.match.match_date, "yyyy-MM-dd");
      vm.match.match_end_date = $date(vm.match.match_end_date, "yyyy-MM-dd");
      vm.match.registration_start = $date(
        vm.match.registration_start,
        "yyyy-MM-dd"
      );
      vm.match.registration_end = $date(
        vm.match.registration_end,
        "yyyy-MM-dd HH:mm"
      );
      vm.match.official = vm.match.official ? 1 : 0;
      vm.match.round_1_mobile_open = vm.match.round_1_mobile_open ? 1 : 0;
      vm.match.round_2_mobile_open = vm.match.round_2_mobile_open ? 1 : 0;
      vm.match.cup = vm.match.cup ? 1 : 0;
      vm.match.championship = vm.match.championship ? 1 : 0;
      vm.match.matchJudges = vm.selectedJudges;
      if (vm.match.match_id) {
        /* UPDATE MATCH */
        MatchesFactory.update(vm.match.match_id, vm.match).then((response) => {
          ngDialog.open({ template: "successTemplate" });
          $state.reload();
        });
      } else {
        /* NEW MATCH */
        MatchesFactory.add(vm.match).then((response) => {
          ngDialog.open({ template: "successTemplate" });
          $state.go("match-edit", { id: response.data.match_id });
        });
      }
    };
  }
}

export default MatchEditController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchEdit/matchEdit.controller.js